import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { vacancyQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { OrderedSectionName } from "@/types/request/UpdateClientDescriptionsOrderRequest";

type UseVacancyDescriptionsParams = {
  groupNames: string[];
  clientId?: string;
};

type VacancyDescriptionsResponse = {
  data: OrderedSectionName[];
};

export const useVacancyDescriptions = ({
  groupNames,
  clientId,
}: UseVacancyDescriptionsParams) => {
  const {
    data,
    isLoading,
    isFetching,
    error,
  }: UseQueryResult<VacancyDescriptionsResponse, AxiosError> = useQuery({
    queryKey: vacancyQueryKeys.description(groupNames, clientId),
    queryFn: () =>
      instance
        .post("/api/v2/Vacancies/Descriptions/Active", { clientId, groupNames })
        .then((res) => res.data),
    enabled: groupNames.length > 0,
    refetchOnWindowFocus: false,
  });

  return {
    descriptions: data?.data ?? [],
    descriptionsLoading: isLoading || isFetching,
    descriptionsError: error,
  };
};
